<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardBody>
          <AppForm 
            :key="appFormKey"
            :vo-name="isEdit ? 'CourseTeacherGetVo' : 'CourseTeacherAddVo'"
            :data="tmpCourseTeacher" 
            @changed="onFormChange"
          />
        </CCardBody>
        <CCardFooter>
          <LoadingStateButton
            @click="onAddOrUpdateCourseTeacher"
            :text="i18nMessage.Apply"
            color="primary"
            :loading="updateCourseTeacherLoading"
          />
          <template v-if="isEdit">
            &nbsp;
            <CButton color="secondary" @click="showDeleteModal = true">{{i18nMessage.Delete}}</CButton>
          </template>
          &nbsp;
          <CButton color="secondary" @click="goBack">{{i18nMessage.Back}}</CButton>
        </CCardFooter>
      </CCard>
    </CCol>
    <CModal
      :show.sync="showDeleteModal"
      :centered="true"
      color="default"
    >
      {{i18nMessage.PleaseInputTextToConfirmDelete}} <b>{{courseTeacher.name}}</b>
      <br/><br/>
      <CInput
          :placeholder="i18nMessage.PleaseInputText"
          v-model="deleteConfirmText"
        />
      <template #header>
        <span class="modal-title">{{i18nMessage.Delete}}？</span>
        <CButtonClose @click="showDeleteModal = false" class="text-dark"/>
      </template>
      <template #footer>
        <LoadingStateButton
          :disabled="deleteConfirmText !== courseTeacher.name"
          @click="onDeleteCourseTeacher"
          :text="i18nMessage.Apply"
          color="danger"
          :loading="deleteCourseTeacherLoading"
        />
        <CButton @click="showDeleteModal = false" color="secondary">{{i18nMessage.Cancel}}</CButton>
      </template>
    </CModal>
  </CRow>
</template>

<script>
import { mapState, mapActions, mapMutations, } from 'vuex'
import { generateGUID } from '../../util'
import AppForm from '../../components/AppForm'
import LoadingStateButton from '../../components/LoadingStateButton'

export default {
  name: 'CourseTeacher',
  components: {
    AppForm,
    LoadingStateButton,
  },
  data () {
    return {
      deleteConfirmText: null,
      showDeleteModal: false,
      isEdit: this.$route.params.id && this.$route.params.id.length > 0,
      tmpCourseTeacher: {},
      updateCourseTeacherLoading: false,
      deleteCourseTeacherLoading: false,
      appFormKey: generateGUID(),
    }
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
      courseTeacher: state => state.course.courseTeacher,
      defaultGlobalStyles: state => state.defaultGlobalStyles,
    }),
  },
  methods: {
    ...mapActions({
      getCourseTeacher: 'course/getCourseTeacher',
      updateCourseTeacher: 'course/updateCourseTeacher',
      addCourseTeacher: 'course/addCourseTeacher',
      deleteCourseTeacher: 'course/deleteCourseTeacher',
    }),
    ...mapMutations({
      setCourseTeacher: 'course/setCourseTeacher',
    }),
    goBack() {
      this.$router.push({path: '/course-teacher'})
    },
    onFormChange (data) {
      this.tmpCourseTeacher = {...data}
    },
    onAddOrUpdateCourseTeacher () {
      if (this.tmpCourseTeacher.id) {
        this.updateCourseTeacherLoading = true
        this.updateCourseTeacher(this.tmpCourseTeacher)
          .then(() => {
            this.updateCourseTeacherLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateCourseTeacherLoading = false
          })
      } else {
        this.updateCourseTeacherLoading = true
        this.addCourseTeacher(this.tmpCourseTeacher)
          .then(() => {
            this.updateCourseTeacherLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateCourseTeacherLoading = false
          })
      }
    },
    onDeleteCourseTeacher () {
      this.deleteCourseTeacherLoading = true
      this.deleteCourseTeacher(this.courseTeacher.id)
          .then(() => {
            this.deleteCourseTeacherLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.deleteCourseTeacherLoading = false
            this.showDeleteModal = false
          })
    }
  },
  mounted() {
    if (this.isEdit) {
      this.getCourseTeacher(this.$route.params.id).then(() => {
        this.tmpCourseTeacher = this.courseTeacher
      })
    }
  },
  destroyed() {
    this.setCourseTeacher({})
  }
}
</script>

<style>
  .section-modal.overlay {
    position: fixed;
    width: 100%;
    height: 100vh;
    left: 0;
    top: 0;
    background: rgba(51,51,51,0.7);
    z-index: 10;
  }

  .section-modal > .modal-header {
    padding: 5px;
  }

  .section-modal > .modal-content {
    overflow: hidden;
  }

  .section-modal > .modal-body {
    overflow-y: scroll;
    padding: 0px;
  }

  .section-modal > .modal-footer {
    display: none;
  }
</style>